let apiURL = process.env.REACT_APP_BASE_API_URL;

export const getApiUrl = () => {
    return apiURL;
}



// WEBPACK FOOTER //
// ./src/config.js